import { Box, Button } from "@modernatx-internal/component-library";
import React from "react";

import { useFinder } from "@/finder/hooks/V2/useFinder";

import { PrefectureSearch } from "./Search/PrefectureSearch";
import { Search } from "./Search/Search";

interface MobileControlsProps {
  searchProps?: React.ComponentProps<typeof Search>;
  prefectureSearchProps?: React.ComponentProps<typeof PrefectureSearch>;
  showMobileMap?: boolean;
}

const TABS = ["mobileList", "mobileMap"] as const;

const MobileControls: React.FC<MobileControlsProps> = ({
  searchProps,
  prefectureSearchProps,
  showMobileMap = true
}) => {
  const { resultsView, resultsViewSet, mobileNavLocalizedHeaders } = useFinder();

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderBottom: ["1px solid", null, "none"],
        borderBottomColor: "color-system-gray-300",
        display: ["flex", null, "none"],
        flexDirection: "column",
        paddingBottom: "spacing-3"
      }}
    >
      {searchProps ? (
        <Search {...searchProps} showMobileSearchButton={!showMobileMap} />
      ) : prefectureSearchProps ? (
        <PrefectureSearch {...prefectureSearchProps} />
      ) : null}
      {showMobileMap && (
        <Box
          sx={{
            backgroundColor: "white",
            display: ["flex", null, "none"],
            justifyContent: "space-around"
          }}
        >
          {TABS.map((view) => (
            <Button
              key={view}
              variant="subtle"
              size="lg"
              sx={{
                borderBottom: resultsView === view ? "4px solid" : "none",
                borderColor: "button-surface-filled-enabled",
                borderRadius: undefined,
                boxSizing: "content-box",
                color: resultsView === view ? "button-surface-filled-enabled" : "text-default",
                fontSize: "font-size-5",
                fontWeight: "font-weight-regular",
                py: 0
              }}
              onClick={() => resultsViewSet(view)}
            >
              {mobileNavLocalizedHeaders[view]}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default MobileControls;
